import React from 'react'
import Nav from '../Nav/index'
import Footer from '../Footer/index'
import Hero from './Hero/index'
import Content from './Content/index'
import Faqs from './Faqs/index'
import { Helmet } from 'react-helmet'


function index() {


  return (
    <>
            <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11084448289"></script>
                    
                    <title>Professional Home Wound Dressing Services at Kyno Health Center</title>
                    <meta name="description" content="At Kyno Healthcare Center, we understand that wounds require careful attention and specialized care to ensure proper healing. " data-react-helmet="true"/>
                    <link rel="canonical" href="https://www.kynohealth.com/"/>

            </Helmet>
        
    <Nav/>
    <Hero/>
    <Content/>
    <Faqs/>
    <Footer/>
    </>
  )
}





export default index